import { Component } from '@angular/core';

@Component({
  selector: 'howden-file-library-template',
  templateUrl: './file-library-template.component.html',
  styleUrls: ['./file-library-template.component.scss']
})
export class FileLibraryTemplateComponent {
}
